// Products.tsx
import React from 'react'

import { Avatar, Tag, Rate } from 'antd'
import { useGetRevenueQuery } from '@/services/api/transaction/transactionApi'
import { CustomDataTable } from '@/components/UI/Tables/Datatable'

const Products = () => {
  const { data: apiResponse, isLoading, isFetching } = useGetRevenueQuery()
  
  const productsData = apiResponse?.top_products || []

  const columns = [
    {
      title: 'Product',
      dataIndex: 'product_name',
      key: 'product_name',
      width: 300,
      render: (text, record) => (
        <div className="flex items-center gap-3">
          <Avatar 
            src={record.product_url} 
            size={48} 
            shape="square"
            className="rounded-lg"
          />
          <div className="flex flex-col">
            <span className="font-medium text-gray-900">{text}</span>
            <Rate 
              disabled 
              value={parseFloat(record.product_rating)} 
              className="text-xs"
            />
          </div>
        </div>
      ),
    },
    {
      title: 'Order Type',
      dataIndex: 'order_type',
      key: 'order_type',
      width: 150,
      render: (type) => (
        <Tag color="blue">{type}</Tag>
      ),
    },
    {
      title: 'Total Orders',
      dataIndex: 'total_orders',
      key: 'total_orders',
      width: 120,
      align: 'center',
      sorter: (a, b) => a.total_orders - b.total_orders,
    },
    {
      title: 'Units Sold',
      dataIndex: 'total_units_sold',
      key: 'total_units_sold',
      width: 120,
      align: 'center',
      sorter: (a, b) => parseInt(a.total_units_sold) - parseInt(b.total_units_sold),
    },
    {
      title: 'Revenue',
      dataIndex: 'total_amount',
      key: 'total_amount',
      width: 150,
      align: 'right',
      sorter: (a, b) => parseFloat(a.total_amount) - parseFloat(b.total_amount),
      render: (amount) => (
        <span className="font-semibold text-gray-900">
          ₦{parseFloat(amount).toLocaleString('en-NG', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
          })}
        </span>
      ),
    },
  ]

  return (
    <div>
      <CustomDataTable
        data={productsData}
        columns={columns}
        loading={isLoading || isFetching}
        title='Top Performing Products'
        // showTitle={false}
        // showSearch={true}
        searchPlaceholder="Search products..."
        pagination={true}
        pageSize={10}
        pageSizeOptions={["10", "20", "50"]}
        rowKey="id"
        // noborder
      />
    </div>
  )
}

export default Products